module.exports = __webpack_public_path__ + "img/zhujiangcheng.736e1e67.jpg";